import moment from "moment";

export default {
  formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";
    const cleaned = phoneNumber.replace(/\D+/g, "").replace(/^(0|9)+/g, "");
    if (cleaned.length >= 10) {
      return (
        "(" +
        cleaned.substring(0, 3) +
        ")" +
        " " +
        cleaned.substring(3, 6) +
        "-" +
        cleaned.substring(6, 8) +
        cleaned.substring(8)
      );
    } else {
      return phoneNumber;
    }
  },
  formatMilliSecondsToDate(ms) {
    if (!ms) return "";
    return moment(String(new Date(ms))).format("DD/MM/YYYY");
  }
};



// WEBPACK FOOTER //
// ./src/filters/filters.js